window.addEventListener('load', function () {
  if (document.getElementById('impactTab1')) {
    var thisTab = document.getElementById('impactTab1');
    var tabs = thisTab.getElementsByClassName('ctpx-tab');
    var tabNav = thisTab.getElementsByClassName('ctpx-tab-nav');

    //if the window is small
    if (window.innerWidth > 768) {
      //console.log('window big');
      // if there is more than 1 tab
      if (tabs.length > 1) {
        // Tabs
        const tabSystem = {
          init() {
            // Each Tab Nav Item
            thisTab.querySelectorAll('.tab-nav').forEach((tabMenu) => {
              Array.from(tabMenu.children).forEach((child, ind) => {
                child.addEventListener('click', () => {
                  tabSystem.toggle(child.dataset.target);
                });
                if (child.className.includes('active')) {
                  tabSystem.toggle(child.dataset.target);
                }
              });
            });
          },
          toggle(targetId) {
            // Each Tab Content Block
            thisTab.querySelectorAll('.ctpx-tab').forEach((contentElement) => {
              contentElement.style.display =
                contentElement.id === targetId ? 'block' : 'none';
              thisTab
                .querySelector(`[data-target="${contentElement.id}"]`)
                .classList[contentElement.id === targetId ? 'add' : 'remove'](
                  'active'
                );
            });
          },
        };
        // use it
        tabSystem.init();
      }
    }
  }

  if (document.getElementById('impactTab2')) {
    var tab2 = document.getElementById('impactTab2');
    var tabs2 = tab2.getElementsByClassName('ctpx-tab');
    var tabNav2 = tab2.getElementsByClassName('ctpx-tab-nav');
    //if the window is small
    if (window.innerWidth > 768) {
      //console.log('window big');
      // if there is more than 1 tab
      if (tabs2.length > 1) {
        // Tabs
        const tabSystem2 = {
          init() {
            // Each Tab Nav Item
            tab2.querySelectorAll('.tab-nav').forEach((tabMenu2) => {
              Array.from(tabMenu2.children).forEach((child, index, arr) => {
                child.addEventListener('click', () => {
                  tabSystem2.stopAllVideos(); // Stop videos before switching tabs
                  tabSystem2.toggle(child.dataset.target);
                });

                if (child.classList.contains('active')) {
                  tabSystem2.toggle(child.dataset.target);
                }
              });
            });

            // Add event listener for "Next Tab" button
            tab2.querySelectorAll('.next-tab-btn').forEach((button) => {
              button.addEventListener('click', tabSystem2.nextTab);
            });
          },

          toggle(targetId) {
            // Each Tab Content Block
            tab2.querySelectorAll('.ctpx-tab').forEach((contentElement) => {
              const isActive = contentElement.id === targetId;
              contentElement.style.display = isActive ? 'block' : 'none';
              tab2
                .querySelector(`[data-target="${contentElement.id}"]`)
                .classList[isActive ? 'add' : 'remove']('active');
            });
          },

          nextTab() {
            const activeTab = tab2.querySelector('.tab-nav .active');
            if (!activeTab) return;

            const tabs = Array.from(tab2.querySelectorAll('.tab-nav > *'));
            const currentIndex = tabs.indexOf(activeTab);

            if (currentIndex < tabs.length - 1) {
              const nextTab = tabs[currentIndex + 1];
              tabSystem2.stopAllVideos();
              tabSystem2.toggle(nextTab.dataset.target);
            }
          },

          stopAllVideos() {
            tab2.querySelectorAll('iframe').forEach((iframe) => {
              if (iframe.src.includes('youtube.com') && iframe.contentWindow) {
                // Stop video using YouTube API
                iframe.contentWindow.postMessage(
                  '{"event":"command","func":"stopVideo","args":""}',
                  '*'
                );
              }
            });
          },
        };

        // Initialize the tab system
        tabSystem2.init();
      }
    }
  }
  if (window.location.hash) {
    const targetElement = document.querySelector(window.location.hash);
    if (targetElement) {
      setTimeout(function () {
        targetElement.scrollIntoView();
      }, 0);
    }
  }
});
